const Marketing = () => {
  return <>마케팅 도우미</>;
};
export default Marketing;
